import React, { useEffect } from "react";
import {
  Layout,
  Form,
  Input,
  Button,
  Typography,
  Spin,
  Alert,
  Row,
  Col,
  Divider,
  Image,
} from "antd";
import { useSelector, useDispatch } from "react-redux";
import { masterRegister, toggleTheme } from "../../actions/UserActions";
import logo from "../../assets/logo.png";
import dayjs from "dayjs";
import { MoonFilled, SunFilled } from "@ant-design/icons";
import { auth } from "../../App";
import { Link, Navigate } from "react-router-dom";
import "./Login.css"; // Add your styles here
import { logPageVisit } from "../../actions/AnalyticsActions";

const { Title } = Typography;
const { Content } = Layout;

const RegisterStaff = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  // Redux state selectors
  const loading = useSelector((state) => state.user.loading);
  const error = useSelector((state) => state.user.error);
  const success = useSelector((state) => state.user.success);
  const isLightTheme = useSelector((state) => state.user.theme.isLightTheme);

  
    useEffect(() => {
      dispatch(logPageVisit("Register"));
    }, [dispatch]);
  

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (success) {
      form.resetFields();
    }
  }, [success, form]);

  const handleToggle = () => {
    dispatch(toggleTheme());
  };

  const onFinish = (values) => {
    if (values.password !== values.confirmPassword) {
      form.setFields([
        { name: "confirmPassword", errors: ["Passwords do not match"] },
      ]);
      return;
    }
    dispatch(
      masterRegister({
        ...values,
        role: "newStaff",
        time: dayjs().valueOf(),
      })
    );
  };

  if (auth.currentUser) {
    // if (user) {
    // User logged in
    return <Navigate to="/dashboard" />;
  }

  return (
    <Layout style={{ minHeight: "100vh", background: 'linear-gradient(135deg, #059941, #2f3589) ' }}>
      <Content
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 24,
          width: '100%'
        }}
      >
        <Spin spinning={loading} style={{    width: '100%'}}>
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            autoComplete="off"
            style={{
              maxWidth: 600,
              width:'100%',
              padding: 24,
              backgroundColor: "#ffffff",
              borderRadius: 8,
              border: "1px solid #d9d9d9",
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
              
            }}
          >
            <Row
              align="middle"
              style={{ display: "flex", justifyContent: "center", marginBottom: 30 }}
            >
              {/* Logo */}
              {/* <Col>
                <Image
                  style={{ width: 150, height: 150 }}
                  src={logo}
                  alt="Logo"
                  preview={false}
                />
              </Col>

              <Col>
                <Divider
                  type="vertical"
                  style={{
                    height: 50,
                    backgroundColor: "#1890ff",
                    marginLeft: 20,
                    marginRight: 20,
                  }}
                />
              </Col> */}

              {/* Title */}
              <Col style={{ alignItems: "center" }}>
                <Title level={2} style={{ color: "var(--secondary)", margin: 0, textAlign: 'center' }}>
                  Sanecka Brand
                </Title>
                <Title level={3} style={{ color: "var(--primary)", margin: 0, textAlign: 'center' }}>
                  We free you from stress
                </Title>

              </Col>
            </Row>

            {/* Error Message */}
            {error?.code && (
              <Alert
                message="Error"
                description={error.message}
                type="error"
                showIcon
                style={{ marginBottom: 20 }}
              />
            )}

            {/* Success Message */}
            {success && (
              <Alert
                message="Success"
                description="User registered successfully!"
                type="success"
                showIcon
                style={{ marginBottom: 20 }}
              />
            )}

            {/* Name Input */}
            <Form.Item
              label="Full Name"
              name="name"
              rules={[{ required: true, message: "Please enter the full name" }]}
            >
              <Input placeholder="Enter full name" />
            </Form.Item>

            {/* Email Input */}
            <Form.Item
              label="Email"
              name="email"
              rules={[
                { required: true, message: "Please enter the email" },
                { type: "email", message: "Please enter a valid email" },
              ]}
            >
              <Input placeholder="Enter email address" />
            </Form.Item>

            {/* Password Inputs */}
            <Form.Item
              label="Password"
              name="password"
              rules={[{ required: true, message: "Please enter a password" }]}
            >
              <Input.Password placeholder="Enter password" />
            </Form.Item>

            <Form.Item
              label="Confirm Password"
              name="confirmPassword"
              rules={[
                { required: true, message: "Please re-enter password to confirm" },
              ]}
            >
              <Input.Password placeholder="Confirm password" />
            </Form.Item>

            <Form.Item
              label="Master Code"
              name="masterCode"
              rules={[{ required: true, message: "Please enter the Master Code" }]}
            >
              <Input.Password placeholder="Enter master code" />
            </Form.Item>

            {/* Submit Button */}
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                style={{
                  width: "100%",
                  backgroundColor: "#1890ff",
                  borderColor: "#1890ff",
                }}
              >
                Register
              </Button>
            </Form.Item>

            <div style={{justifyItems:'center'}} className="login-footer">
            <p style={{padding:'0 70px', textAlign:'center'}}>You need to have the necessary master code to create an account</p>

              <p>
                Are you a member? <Link to="/login">Login</Link>
              </p>
            </div>
          </Form>
        </Spin>
      </Content>
    </Layout>
  );
};

export default RegisterStaff;
